import React from 'react';
import { Link } from 'react-router-dom';

export default ({ children, to, ...props }) => <Link to={{ pathname: to, state: { fromLink: true }}} {...props}>{children}</Link>